// extracted by mini-css-extract-plugin
export default {"formSection":"freeze-fee-form_formSection__LFq5A"};